/**
 * A GraphQL server returns HTTP 200 with `{ data: null, errors: [...] }` on a resolver/validation
 * failure, so `authenticatedPost` never throws for that shape on its own — every fetcher must
 * check for it explicitly before trusting `result.data`.
 */
export function throwOnGraphQLErrors(result: { errors?: { message?: string }[] }): void {
  if (result.errors && result.errors.length > 0) {
    throw new Error(result.errors[0]?.message ?? 'GraphQL request failed');
  }
}
